import { createContext, useState, useEffect } from "react";
import { axiosPrivate } from "../services/axios";
import { JSON_CONFIG_FILE_NAMES } from "../utils/budgeto_app_settings/jsonConfigFileNames";
import ConfigAPI from "../services/ConfigServices";

// Create context with default values
const NavigationContext = createContext({
  navigationJson: {},
  clientBusinessUnits: null,
  estimationConfig: null,
  employeeManagementConfig: null,
  labelsConfig: null,
  invoiceTemplateKeys: null
});

export const NavigationProvider = ({ children }) => {
  const getInitialNavigationJson = () => {
    try {
      const cached = localStorage.getItem("navigationJson");
      return cached ? JSON.parse(cached) : {};
    } catch {
      return {};
    }
  };

  const [navigationJson, setNavigationJson] = useState(
    getInitialNavigationJson
  );
  const [clientBusinessUnits, setClientBusinessUnits] = useState(null);
  const [estimationConfig, setEstimationConfig] = useState(null);
  const [employeeManagementConfig, setEmployeeManagementConfig] =
    useState(null);
  const [labelsConfig, setLabelsConfig] = useState(null);
  const [invoiceTemplateKeys, setInvoiceTemplateKeys] = useState(null);

  const loadJsonConfigs = async () => {
    try {
      const [
        navResp,
        empResp,
        clientBUResp,
        estimationResp,
        labelsResp,
        invoiceTemplateResp
      ] = await Promise.all([
        ConfigAPI.GET_JSON_CONFIG(
          axiosPrivate,
          JSON_CONFIG_FILE_NAMES.SUB_NAVIGATION_LABEL_CONFIG
        ),
        ConfigAPI.GET_JSON_CONFIG(
          axiosPrivate,
          JSON_CONFIG_FILE_NAMES.EMPLOYEE_MANAGEMENT_CONFIG
        ),
        ConfigAPI.GET_JSON_CONFIG(
          axiosPrivate,
          JSON_CONFIG_FILE_NAMES.CLIENT_BUSINESS_UNITS
        ),
        ConfigAPI.GET_JSON_CONFIG(
          axiosPrivate,
          JSON_CONFIG_FILE_NAMES.ESTIMATION_CONFIG
        ),
        ConfigAPI.GET_JSON_CONFIG(
          axiosPrivate,
          JSON_CONFIG_FILE_NAMES.LABELS_CONFIG
        ),
        ConfigAPI.GET_JSON_CONFIG(
          axiosPrivate,
          JSON_CONFIG_FILE_NAMES.INVOICE_TEMPLATE_KEYS
        )
      ]);

      if (navResp.data) {
        setNavigationJson(navResp.data);
        localStorage.setItem("navigationJson", JSON.stringify(navResp.data));
      }

      if (empResp.data) setEmployeeManagementConfig(empResp.data);
      if (clientBUResp.data) setClientBusinessUnits(clientBUResp.data);
      if (estimationResp.data) setEstimationConfig(estimationResp.data);

      if (labelsResp.data) {
        setLabelsConfig(labelsResp.data);
        localStorage.setItem("labelsConfig", JSON.stringify(labelsResp.data));
      }

      if (invoiceTemplateResp.data) {
        setInvoiceTemplateKeys(invoiceTemplateResp.data);
      }
    } catch (error) {
      console.error("Error loading JSON configs:", error);
    }
  };

  useEffect(() => {
    loadJsonConfigs();
  }, []);

  return (
    <NavigationContext.Provider
      value={{
        navigationJson,
        clientBusinessUnits,
        estimationConfig,
        employeeManagementConfig,
        labelsConfig,
        invoiceTemplateKeys
      }}
    >
      {children}
    </NavigationContext.Provider>
  );
};

export default NavigationContext;
